<template>
  <BaseModal :show="show"
             title="Важное уведомление"
             :description="notification.message">
    <template #description-slot>
      <div class="notification-message">
        <template
            v-for="(part, index) in parseTextLinks(notification.message)"
        >
          <a
              v-if="part.type === 'link'"
              :key="`link-${index}`"
              :href="part.value"
              target="_blank"
              rel="noopener noreferrer"
          >{{ part.value }}</a>
          <span v-else :key="`text-${index}`">{{ part.value }}</span>
        </template>
      </div>
    </template>
    <div class="buttons">
      <button class="button secondary" type="button" @click="$emit('read', notification)">Прочитано</button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/common/BaseModal";
import {parseTextLinks} from "@/helpers/linkParser";

export default {
  props: ['show', 'notification'],
  components: {BaseModal},
  methods: {
    parseTextLinks,
  },
}
</script>

<style scoped>
.notification-message {
  white-space: pre-wrap;
}

.notification-message a {
  color: #00669c;
}
</style>
